/* eslint-disable */
import React from 'react'
import {message, Pagination} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import CRM from './CRM'
import Select from 'react-select'

class SearchCustomer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchModalCustomer: false,
      showTable: false,
      searchedCustomer: [],
      partSearchedCustomer: [],
      pageNumber: 1,
      current: 1,
      lengthSearchByCode: '',
      selectedCustomerId: [],
      arrayOfCustomer: [],
      finalCustomer: [],
      singleSelectedCode: ''
    }
  }
  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.getValueFromThisPage !== this.props.getValueFromThisPage) {
      this.setState({
        singleSelectedCode: this.props.getValueFromThisPage
      })
    }
  }

  openCodeForm() {
    this.setState({
      searchModalCustomer: !this.state.searchModalCustomer
    })
  }

  toggleByCode = () => {
    this.setState({
      searchModalCustomer: !this.state.searchModalCustomer
    })
  }

  cancelByCode = () => {
    this.setState({
      searchModalCustomer: !this.state.searchModalCustomer
    })
  }

  searchByCode() {
    var CustomerCode = document.getElementById('CustomerCode').value
    var CustomerMobile = document.getElementById('CustomerMobile').value
    var nationalId = document.getElementById('nationalId').value
    var CustomerFirstName = document.getElementById('CustomerFirstName').value
    var CustomerLastName = document.getElementById('CustomerLastName').value
    if (
      nationalId == '' &&
      CustomerCode == '' &&
      CustomerMobile == '' &&
      CustomerFirstName == '' &&
      CustomerLastName == ''
    ) {
      message.error('حداقل یک فیلد وارد شود')
    } else {
      http
        .get(
          `${
            CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INFO
          }?nationalId=${nationalId}&customerCode=${CustomerCode}&mobile=${CustomerMobile}&firstname=${CustomerFirstName}&lastname=${CustomerLastName}&export=true`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            let result = response.data.object.result
            for (let i = 0; i < result.length; i++) {
              result[i]['isChecked'] = false
            }

            this.setState({
              selectedRadio: '',
              searchedCustomer: response.data.object.result,
              partSearchedCustomer: response.data.object.result.slice(0, 10),
              lengthSearchByCode: response.data.object.countAll,
              showTable: true
            })
          } else {
            this.setState({
              searchedCustomer: [],
              partSearchedCustomer: [],
              showTable: false
            })
          }
        })
    }
  }

  onChangePage(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partSearchedCustomer: this.state.searchedCustomer.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  selectButton = (numId) => {
    this.setState({
      singleSelectedCode: this.state.searchedCustomer[numId - 1].code.toString(),
      searchModalCustomer: !this.state.searchModalCustomer
    })
    this.props.getSingleCustomerCode(this.state.searchedCustomer[numId - 1].code)
  }

  getFinalSingleCustomerCode = (e) => {
    let value = e.target.value
    this.setState({
      singleSelectedCode: value
    })

    this.props.getSingleCustomerCode(value)
  }

  changeCheckBox = (numId, pageNum) => {
    let {selectedCustomerId} = this.state

    this.setState(() => {
      let newSelectedCustomerId = this.state.searchedCustomer
      newSelectedCustomerId[numId - 1].isChecked = !newSelectedCustomerId[numId - 1].isChecked
      if (newSelectedCustomerId[numId - 1].isChecked) {
        selectedCustomerId.push(newSelectedCustomerId[numId - 1].code)

        this.setState({
          selectedCustomerId
        })
      } else {
        const index = selectedCustomerId.indexOf(newSelectedCustomerId[numId - 1].code)
        selectedCustomerId.splice(index, 1)
        this.setState({
          selectedCustomerId
        })
      }
      return {
        searchedCustomer: newSelectedCustomerId,
        partSearchedCustomer: this.state.searchedCustomer.slice((pageNum - 1) * 10, pageNum * 10)
      }
    })
  }

  selectedCustomer = () => {
    let {selectedCustomerId} = this.state

    if (selectedCustomerId.length == 0) {
      message.error('مشتری را انتخاب کنید سپس تایید کنید')
    } else {
      var arrayOfCustomer = []
      var finalCustomer = []

      for (let i = 0; i < selectedCustomerId.length; i++) {
        let object = {
          label: selectedCustomerId[i],
          value: selectedCustomerId[i]
        }
        arrayOfCustomer.push(object)
        finalCustomer.push(object.value)
        this.setState({
          arrayOfCustomer,
          searchModalCustomer: !this.state.searchModalCustomer,
          finalCustomer
        })
        this.props.getCustomerCode(arrayOfCustomer)
      }
    }
  }

  handleChangeCustomer = (arrayOfCustomer) => {
    var stockArr = []
    this.setState({arrayOfCustomer})
    // this.props.getStocks(arrayOfStocks)
    if (arrayOfCustomer.length == '0') {
      // this.props.finalStocks([])

      this.props.finalCustomer([])

      this.setState({
        finalCustomer: []
      })
    } else {
      for (let prop of arrayOfCustomer) {
        stockArr.push(prop.value)
        this.setState({
          finalCustomer: stockArr
        })
        this.props.finalCustomer(stockArr)

        // this.props.finalStocks(stockArr)
      }
    }
  }

  render() {
    let pageSize = 10
    let {arrayOfCustomer} = this.state
    let pageNumber = this.state.current

    return (
      <React.Fragment>
        <div className="formComponent">
          <label className="hiddenLabel">sdfdsf</label>

          <span onClick={this.openCodeForm.bind(this)} className="searchCRM">
            {'فرم جست و جوی مشتری'}
          </span>
        </div>

        {this.props.singleResult ? (
          <div className="formComponent">
            <label>
              {this.props.label}
              <span
                style={this.props.force ? {visibility: 'visible'} : {visibility: 'hidden'}}
                className="requireFiled"
              >
                *
              </span>
            </label>
            <input
              type="text"
              value={this.state.singleSelectedCode}
              onChange={this.getFinalSingleCustomerCode}
              name={'customerCode'}
              className="form-control"
            />
          </div>
        ) : (
          <div className="formComponent">
            <label>
              {this.props.label}
              <span
                style={this.props.force ? {visibility: 'visible'} : {visibility: 'hidden'}}
                className="requireFiled"
              >
                *
              </span>
            </label>
            <Select
              value={arrayOfCustomer}
              onChange={this.handleChangeCustomer}
              options={this.state.arrayOfStocks}
              isMulti={true}
              placeholder=""
            />
          </div>
        )}

        <Modal isOpen={this.state.searchModalCustomer} toggle={this.toggleByCode} size="lg">
          <ModalHeader toggle={this.toggleByCode}>جست و جوی مشتری</ModalHeader>

          <ModalBody>
            <div className="modalForm searchProduct">
              <figure>
                <label>کد مشتری : </label>
                <input type="text" className="form-control" id="CustomerCode" />
              </figure>
              <figure>
                <label>موبایل : </label>
                <input type="text" className="form-control" id="CustomerMobile" />
              </figure>
              <figure>
                <label>نام : </label>
                <input type="text" className="form-control" id="CustomerFirstName" />
              </figure>
              <figure>
                <label>نام خانوادگی : </label>
                <input type="text" className="form-control" id="CustomerLastName" />
              </figure>
              <figure>
                <label>کد ملی : </label>
                <input type="text" className="form-control" id="nationalId" />
              </figure>
              <figure>
                <label className="hiddenLabel">332</label>
                <span onClick={this.searchByCode.bind(this)} className="searchCustommer">
                  جست و جو
                </span>
              </figure>
            </div>
            <div style={this.state.showTable ? {display: 'block'} : {display: 'none'}}>
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>#</td>
                  <td>نام</td>
                  <td>نام خانوادگی</td>
                  <td>کد مشتری</td>
                  <td>موبایل</td>
                  <td>کد ملی</td>
                </tr>
                {this.state.partSearchedCustomer.map((customer, index) => (
                  <tr>
                    <td>{(pageNumber - 1) * 10 + index + 1}</td>
                    <td>
                      {this.props.singleResult ? (
                        <button
                          className="btn btn-sm"
                          style={{color: '#000', fontWeight: '600'}}
                          onClick={() => this.selectButton((pageNumber - 1) * 10 + index + 1)}
                        >
                          انتخاب
                        </button>
                      ) : (
                        <input
                          type="checkbox"
                          value={customer.code}
                          checked={customer.isChecked}
                          onChange={() => this.changeCheckBox((pageNumber - 1) * pageSize + index + 1, pageNumber)}
                        />
                      )}
                    </td>
                    <td>{customer.firstName}</td>
                    <td>{customer.lastName}</td>
                    <td>{customer.code}</td>
                    <td>{customer.phoneNumber}</td>
                    <td>{customer.nationalId}</td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pagination
                  current={this.state.current}
                  onChange={this.onChangePage.bind(this)}
                  total={this.state.lengthSearchByCode}
                />
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.cancelByCode}>
              لغو
            </button>
            {/* <button className='confirmBtnModal' onClick={this.selectedCustomer}>انتخاب مشتری</button> */}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    )
  }
}
export default SearchCustomer
